import React from "react";
import { IssueStatus } from "src/types";
import { StatusPill } from "src/components/ui";

interface ReceivingDiscrepancyHeadingSectionProps {
  purchaseOrderId: string;
  status?: IssueStatus;
}

const ReceivingDiscrepancyHeadingSection: React.FC<ReceivingDiscrepancyHeadingSectionProps> = ({
  purchaseOrderId,
  status
}) => (
  <div className="flex items-center justify-between flex-wrap gap-4">
    <div>
      <h1 className="text-3xl font-bold text-white tracking-tight">Receiving Discrepancy Issue</h1>
      <p className="text-gray-300 mt-2 text-lg">Purchase Order: {purchaseOrderId}</p>
    </div>
    {status && (
      <div className="flex items-center">
        <StatusPill status={status} />
      </div>
    )}
  </div>
);

export { ReceivingDiscrepancyHeadingSection };
